import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClienteContaDetalharComponent } from './central-cliente-conta-detalhar.component';
import { CentralClienteContaDetalharRoutingModule } from './central-cliente-conta-detalhar-routing.module';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';


@NgModule({
  declarations: [
    CentralClienteContaDetalharComponent
  ],
  imports: [
    CommonModule,
    CentralClienteContaDetalharRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    CalendarModule,
    TooltipModule,
    ProgressSpinnerModule,
    DialogModule,
    InputNumberModule,
    InputMaskModule,
    FormatPipeModule
  ]
})
export class CentralClienteContaDetalharModule { }
